import { render } from "./game-search.vue?vue&type=template&id=515b88fc&scoped=true"
import script from "./game-search.vue?vue&type=script&lang=js"
export * from "./game-search.vue?vue&type=script&lang=js"

import "./game-search.vue?vue&type=style&index=0&id=515b88fc&scoped=true&lang=css"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515b88fc"]])

export default __exports__